import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/geist-mono/wght.css';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

// After a deploy the old page chunks are gone, so reload to get the new ones. Only once a minute, so a judge
// with no signal isn't stuck reloading.
window.addEventListener('vite:preloadError', (event) => {
    const lastReload = Number(sessionStorage.getItem('chunkReloadAt') ?? 0);
    if (Date.now() - lastReload < 60_000) return;
    sessionStorage.setItem('chunkReloadAt', String(Date.now()));
    event.preventDefault();
    window.location.reload();
});

import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
